/**
 * Static content for About page
 * Structured for easy migration to Payload CMS in Epic 3
 */

export const aboutContent = {
	hero: {
		name: "Maryam Ahmed",
		subtitle: "Licensed Interior Designer | Bahrain",
		photo: "/design-refs/logo/maryam-profile.jpg",
		photoAlt: "Professional portrait of Maryam Ahmed, interior designer",
		bio: "With over 5 years of experience transforming spaces across Bahrain and the Gulf region, I bring a unique blend of modern design principles and deep respect for regional aesthetics. My approach combines luxury with functionality, creating environments that reflect both contemporary elegance and cultural heritage. Every project is a collaboration, ensuring your vision becomes a beautiful, functional reality.",
	},
	philosophy: [
		{
			icon: "Sparkles" as const,
			title: "Luxury Meets Functionality",
			description:
				"Creating spaces that are not only visually stunning but also practical and tailored to your lifestyle. Every design decision balances aesthetic appeal with everyday usability.",
		},
		{
			icon: "Globe" as const,
			title: "Cultural Sensitivity",
			description:
				"Drawing inspiration from Bahraini heritage and Gulf traditions while embracing contemporary design trends. Spaces that honor cultural values while feeling fresh and modern.",
		},
		{
			icon: "Users" as const,
			title: "Personalized Approach",
			description:
				"Every client is unique, and so is every project. Through close collaboration, I ensure your personality and needs are reflected in every detail of your space.",
		},
	],
	process: [
		{
			step: 1,
			title: "Concept",
			description:
				"Initial consultation to understand your vision, lifestyle, and requirements. We establish the design direction and project scope.",
		},
		{
			step: 2,
			title: "3D Visualization",
			description:
				"Detailed 3D renders bring your space to life before construction begins, allowing you to experience and refine the design.",
		},
		{
			step: 3,
			title: "Material Selection",
			description:
				"Curated material palettes featuring premium finishes, fabrics, and furnishings that align with your style and budget.",
		},
		{
			step: 4,
			title: "Execution",
			description:
				"Full project management from contractor coordination to final styling, ensuring seamless delivery of your dream space.",
		},
	],
	credentials: {
		license: {
			title: "CRPEP License",
			category: "Category B",
			issuer: "Council for Regulating the Practice of Engineering Professions",
			date: "October 2023",
		},
		education: {
			degree: "B.Sc. Interior Design",
			institution: "University of Bahrain",
			year: "2019",
		},
	},
} as const;

export type AboutContent = typeof aboutContent;

// Flexible types for CMS data (relaxed from const literals)
export type PhilosophyItem = {
	icon: "Sparkles" | "Globe" | "Users";
	title: string;
	description: string;
};

export type ProcessStep = {
	step: number;
	title: string;
	description: string;
};
